(function () {
  'use strict';
  if (customElements.get('leha-site-navigation')) return;
  customElements.define('leha-site-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const close = () => this.querySelectorAll('details[open]').forEach(detail => detail.removeAttribute('open'));
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const detail = event.target.closest('details[open]');
        if (detail) { detail.removeAttribute('open'); detail.querySelector('summary').focus(); event.preventDefault(); }
      }, { signal });
      this.addEventListener('click', event => { if (event.target.closest('.leha-site-header__panel a')) close(); }, { signal });
      document.addEventListener('click', event => { if (!this.contains(event.target)) close(); }, { signal });
      this.addEventListener('focusout', event => { if (event.relatedTarget && !this.contains(event.relatedTarget)) close(); }, { signal });
      const count = this.querySelector('.header-cart-count');
      const description = this.querySelector('[data-leha-cart-count-label]');
      if (count && description) {
        const updateCount = () => {
          const value = count.textContent.trim();
          if (!/^\d+$/.test(value)) return;
          const label = description.dataset.countTemplate.replace('__count__', value);
          if (description.textContent !== label) description.textContent = label;
          const badge = count.closest('.cart-count-bubble');
          if (badge) badge.style.display = Number(value) > 0 ? 'flex' : 'none';
        };
        updateCount();
        this.cartObserver = new MutationObserver(updateCount);
        this.cartObserver.observe(count, { childList:true, characterData:true, subtree:true });
      }
      const refresh = () => {
        this.querySelectorAll('[data-leha-home-target]').forEach(link => {
          if (this.dataset.homepage === 'true') link.closest('li').hidden = !document.getElementById(link.dataset.lehaHomeTarget);
        });
        this.querySelectorAll('a[data-leha-context-link]').forEach(link => {
          if (window.LehaCardPricing) link.href = window.LehaCardPricing.contextUrl(link.href).href;
        });
        this.querySelectorAll('form[role="search"]').forEach(form => {
          const params = new URL(window.location.href).searchParams;
          ['preview_theme_id','preview_key','_fd','_sc','view'].forEach(key => {
            if (!params.has(key) || form.elements.namedItem(key)) return;
            const input = document.createElement('input'); input.type = 'hidden'; input.name = key; input.value = params.get(key); form.append(input);
          });
        });
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once:true, signal }); else refresh();
      document.addEventListener('shopify:section:load', refresh, { signal });
      document.addEventListener('shopify:section:unload', () => queueMicrotask(refresh), { signal });
    }
    disconnectedCallback() { this.controller.abort(); this.cartObserver?.disconnect(); }
  });
})();
